import { render } from "./seo-setup.vue?vue&type=template&id=3c779edc"
import script from "./seo-setup.vue?vue&type=script&lang=js"
export * from "./seo-setup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__